/**
 * *****************************************************************************************
 * Responsibility: Displays the account balance and credit utilization of a user (if net30).
 * *****************************************************************************************
 *
 * @format
 */

/** @format */

import NumberFormat from 'react-number-format';
import {If} from 'frontier-utilities';
import React from 'react';

// styles
import './account_balance.scss';

export const AccountBalance = props => {
    const {dueAmount, pastDueAmount, className, style, current, maxCredit, isNet30} = props;
    const progress = Math.min(100, (current / maxCredit) * 100);

    return (
        <div
            className={`${
                className || ''
            } progress-bar-container-01fg d-flex align-items-end justify-content-start`}
            style={style}>
            <If condition={isNet30}>
                <div className={'progress-bar-container-01fg__credit-container flex-shrink-0'}>
                    <div
                        className={
                            'progress-bar-container-01fg__label d-flex align-items-end justify-content-start'
                        }>
                        <h6>Credit Utilization:</h6>
                        <NumberFormat
                            thousandSeparator={true}
                            value={current}
                            displayType="text"
                            prefix={'$'}
                        />
                        <span>/</span>
                        <NumberFormat
                            thousandSeparator={true}
                            displayType="text"
                            value={maxCredit}
                        />
                        <span>({progress.toFixed(0)}%)</span>
                    </div>

                    <div className="progress-bar-container-01fg__bar-container">
                        <div
                            className="progress-bar-container-01fg__bar"
                            style={{width: `${progress}%`}}></div>
                    </div>
                </div>
            </If>
            <div
                className={
                    'progress-01fg__summary d-flex align-items-end justify-content-end ms-auto me-0'
                }>
                <div className={'progress-summary-01fg__neutral'}>
                    <b>Total Due:</b>
                    <span className={'d-inline-block ms-2'}>
                        <NumberFormat
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            value={dueAmount}
                            displayType="text"
                            decimalScale={2}
                            prefix="$"
                        />
                    </span>
                </div>
                <div
                    className={`progress-summary-01fg__negative ${
                        pastDueAmount > 0 ? 'color-alert-negative' : ''
                    }`}>
                    <b>Past Due:</b>
                    <span className={'d-inline-block ms-2'}>
                        <NumberFormat
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            displayType="text"
                            decimalScale={2}
                            value={pastDueAmount}
                            prefix="$"
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};
